<template>
    <div class="passReset secrecy">
        <div class="pWLeft">
            <el-row>
                <el-col :span="24"><div class="pass-content-left">账号：</div></el-col>
                <el-col :span="24"><div class="pass-content-right">ex_zhangxy6</div></el-col>
            </el-row>
            <el-form :model="passSetForm" ref="passSetForm" :rules="rules">
                <el-form-item
                    label="问题1"
                    prop="problem1"
                    >
                    <el-col :span="16" style="flex: 1;">
                        <el-input size="medium" placeholder="请输入第一个问题" v-model="passSetForm.problem1" auto-complete="off"></el-input>
                    </el-col>
                    <el-col :span="16" style="width: 160px; margin-left: 10px;">
                        <el-input size="medium" placeholder="您的答案" v-model="passSetForm.Answer1" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item
                    label="问题2"
                    prop="problem2"
                    >
                    <el-input size="medium" placeholder="请输入第二个问题" v-model="passSetForm.problem2" auto-complete="off"></el-input>
                    <el-col :span="16" style="width: 160px; margin-left: 10px;">
                        <el-input size="medium" placeholder="您的答案" v-model="passSetForm.Answer2" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item
                    label="问题3"
                    prop="problem3"
                    >
                    <el-input size="medium" placeholder="请输入第三个问题" v-model="passSetForm.problem3" auto-complete="off"></el-input>
                    <el-col :span="16" style="width: 160px; margin-left: 10px;">
                        <el-input size="medium" placeholder="您的答案" v-model="passSetForm.Answer3" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
            </el-form>
            <div class="resetFooter">
                <el-button type="primary" size="medium" @click="confirm" style="width: 100%;">确定</el-button>
                <el-button @click="cancelChange" size="medium" type="text" style="position: absolute; right: -40px; top: 0;">取消</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'setInsurance',
    data () {
        var validatePass = ( rule, value, callback ) => {
            if ( value === '' )
                callback( new Error( '请输入第一个问题' ) );
            else
                callback();
        };
        var validatePass2 = ( rule, value, callback ) => {
            if ( value === '' )
                callback( new Error( '请输入第二个问题' ) );
            else
                callback();
        };
        var validatePass3 = ( rule, value, callback ) => {
            if ( value === '' )
                callback( new Error( '请输入第三个问题' ) );
            else
                callback();
        };
        return {
            passSetForm: {
                problem1: '',
                Answer1: '',
                problem2: '',
                Answer2: '',
                problem3: '',
                Answer3: ''
            },
            rules: {
                problem1: [
                    { required: true, validator: validatePass, trigger: 'blur' }
                ],
                problem2: [
                    { required: true, validator: validatePass2, trigger: 'blur' }
                ],
                problem3: [
                    { required: true, validator: validatePass3, trigger: 'blur' }
                ]
            },
        }
    },
    methods : {
        confirm(){

        },
        cancelChange(){
            this.$router.go(-1);
        }
    }
}
</script>

<style lang="scss" scoped>
.passReset{
    display: flex; align-items: center; justify-content: center; height: 100%; font-size: 12px;
    .pWLeft{
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
        min-width: 40%;
        .el-form{
            height: inherit; width: 100%; margin-top: 10px;
        }
        .el-row{
            width: 100%;
            .pass-content-left{
                min-height: 36px;line-height: 36px; font-weight: 600; color: #2A2A2A;
            }
            .pass-content-right{
                text-align: left; padding-left: 22px; min-height: 36px;line-height: 36px;
                .stateCantent{
                    width: 100%;height: 36px;line-height: 36px;display: flex;align-items:center; margin-bottom: 15px;
                    .passState{
                        display: inline-block;min-width: 30px;
                    }
                    .stateBar{
                         flex: 1; overflow: hidden; float:left;border-radius: 60px;overflow: hidden; background: #f2f2f2;
                        div{
                            height: 8px;
                        }
                        .fade-enter-active, .fade-leave-active{
                            transition: all .3s ease-in;
                        }
                        .fade-enter, .fade-leave-active{
                            opacity: 0;
                        }
                        .stateLow{
                            width: 33%;background: #FE5624;transition: all .7s ease-in;
                        }
                        .stateMiddle{
                            width: 66%;background: #3BA2E9;transition: all .7s ease-in;
                        }
                        .stateStrong{
                            width: 100%;background: #80CD6E;transition: all .7s ease-in;
                        }
                    }
                }
            }
        }
        .resetFooter{
            position: relative; width: 100%; margin-top: 30px;
        }
    }
    .pWRight{
        float: right; margin-left: 30px;
        p{
            font-size: 12px;padding-bottom: 16px; color: #999999;
        }
    }
}
</style>
<style lang="scss">
.secrecy {
    .el-form-item__label{
        float: none; font-size: 12px; font-weight: 600; color: #2A2A2A;
    }
    .el-form-item{
        margin-bottom: 4px;
    }
    .el-form-item .el-form-item__content{
        display: flex;
    }
    .el-form-item .el-form-item__content .el-input{
        flex: 1;
    }
    .el-form-item .el-form-item__content .el-button{
        width: 84px; padding: 0; margin-left: 10px; height: 36px; margin-top: 2px;
    }
    .el-input--medium .el-input__inner{
        font-size: 12px!important;
    }
    .el-button--medium{
        font-size: 12px!important;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/setInsurance.vue